import { Controller } from '@hotwired/stimulus'

// Turbo's `scroll: :preserve` only restores window scroll, not inner scroll
// containers. On morph page refreshes, restore the element's scrollTop so it
// doesn't jump to the top.
export default class extends Controller {
  connect () {
    this.onBeforeRender = this.onBeforeRender.bind(this)
    document.addEventListener('turbo:before-render', this.onBeforeRender)
  }

  disconnect () {
    document.removeEventListener('turbo:before-render', this.onBeforeRender)
  }

  onBeforeRender (event) {
    if (event.detail.renderMethod !== 'morph') {
      return
    }

    const scrollTop = this.element.scrollTop
    document.addEventListener('turbo:render', () => {
      // Restore immediately, then again across the next frames. Other controllers
      // (e.g. text-area-auto-resize) reflow the content on the same turbo:render
      // event, which momentarily shrinks the container and clamps scrollTop. Re-
      // applying after those reflows settle keeps the position stable.
      this.#restore(scrollTop)
    }, { once: true })
  }

  #restore (scrollTop, frames = 2) {
    this.element.scrollTop = scrollTop
    if (frames <= 0) return
    window.requestAnimationFrame(() => this.#restore(scrollTop, frames - 1))
  }
}
